/** Shared display UOM choices for org settings and create-document modals (SC-2494). */
export const DOCUMENT_DISPLAY_UOM_SELECT_DATA = [
  { value: "DEFAULT", label: "Product default" },
  { value: "LB", label: "Pounds (lb)" },
  { value: "KG", label: "Kilograms (kg)" },
] as const;
